import React, { memo } from "react";

import { Handle, Position } from "@xyflow/react";
import { Icon } from "@mui/material";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import { theme } from "../../config/theme";

const CustomNode = ({ data, selected }) => {
  //   let customTitle = { ...style.title };
  //   customTitle.backgroundColor = "#08c9bd";

  return (
    <div className="custom-node">
      <div className="wrapper">
        <div className="heading">
          <Icon
            style={{ marginRight: 8 }}
            color={
              data.label === "Yes"
                ? "success"
                : data.label === "No"
                  ? "error"
                  : "primary"
            }
          >
            monitor
          </Icon>
          <div>{data.heading || "hello"}</div>
        </div>
        <div className="body">{data.label}</div>
      </div>
      <Handle type="source" position={Position.Right} id="b" />
      <Handle type="target" position={Position.Left} id="a" />
    </div>
  );
};

export default memo(CustomNode);
